'use strict';

export class Marquee {
	constructor($element, options = {}) {
		this.$root_element = $element;
		this.$text_element = $element.children().first();
		
		this.scroll_speed = options.scroll_speed || 27;
		this.pause_before = options.pause_before || 1700;
		this.pause_after = options.pause_after || 1700;
		
		this._is_running = false;
		this._overflowing = false;
		this._resize_observer = null;
		this._current_animation = null;
		
		if (!this.$text_element.length) {
			console.warn('Marquee: No child element found inside', $element[0]);
			return;
		}
		
		this._add_classes();
		this._apply_styles();
		this._observe_sizes();
	}
	
	_add_classes() {
		this.$root_element.addClass('js-marquee_container');
		this.$text_element.addClass('js-marquee_text');
	}
	
	_apply_styles() {
		this.$root_element.css({
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			position: 'relative'
		});
		this.$text_element.css({
			display: 'inline-block',
			whiteSpace: 'nowrap',
			transform: 'translateX(0)',
			willChange: 'transform',
			overflow: 'initial',
			textOverflow: 'initial'
		});
	}
	
	_observe_sizes() {
		this._resize_observer = new ResizeObserver(() => {
			this._evaluate_dimensions();
		});
		this._resize_observer.observe(this.$root_element[0]);
		this._resize_observer.observe(this.$text_element[0]);
		
		this._evaluate_dimensions(); // Initial
	}
	
	_evaluate_dimensions() {
		// Wait until all styles and DOM changes have been fully calculated.
		requestAnimationFrame(() => {
			const container_width = this.$root_element[0].clientWidth;
			const text_width = this.$text_element[0].scrollWidth;
			
			const should_scroll = text_width > container_width;
			
			if (should_scroll && !this._is_running) {
				this._overflowing = true;
				this._start_loop();
			} else if (!should_scroll && this._is_running) {
				this.stop();
				this.$text_element.css({ transform: 'translateX(0)' });
			}
		});
	}

	
	async _start_loop() {
		if (this._is_running) {
			return;
		}
		
		this._is_running = true;
		
		while (this._is_running) {
			const container_width = this.$root_element[0].clientWidth;
			const text_width = this.$text_element[0].scrollWidth;
			const distance = text_width - container_width;
			const duration = distance / this.scroll_speed * 1000;
			
			await this._wait(this.pause_before);
			if (!this._is_running) {
				break;
			}
			await this._animate(this.$text_element[0], 0, -distance, duration);
			await this._wait(this.pause_after);
			if (!this._is_running) {
				break;
			}
			await this._animate(this.$text_element[0], -distance, 0, duration);
		}
	}
	
	_animate(element, from_x, to_x, duration) {
		if (!element) {
			return Promise.resolve();
		}
		this._current_animation?.cancel();
		
		this._current_animation = element.animate(
			[
				{ transform: `translateX(${from_x}px)` },
				{ transform: `translateX(${to_x}px)` }
			],
			{
				duration: duration,
				easing: 'linear',
				fill: 'forwards'
			}
		);
		return this._current_animation.finished;
	}
	
	_wait(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}
	
	stop() {
		this._is_running = false;
		this._current_animation?.cancel();
	}
	
	destroy() {
		this.stop();
		this._resize_observer?.disconnect();
		this.$root_element.removeClass('js-marquee_container').removeAttr('style');
		this.$text_element.removeClass('js-marquee_text').removeAttr('style');
	}
}
